import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function ColorVariants({ productId, color, gender }) {
  const [variants, setVariants] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!productId) return;
    setVariants([]);
    axios.get(`${API}/products/${productId}/variants`)
      .then(r => setVariants(Array.isArray(r.data) ? r.data : []))
      .catch(() => setVariants([]));
  }, [productId]);

  const hasSwatches = variants.length > 1;

  return (
    <div className="flex flex-wrap gap-6" data-testid="product-attributes">
      {(color || hasSwatches) && (
        <div className={hasSwatches ? 'w-full' : ''} data-testid="color-variants">
          <p className="text-[10px] uppercase tracking-[0.2em] text-[#AAAAAA] font-work mb-1">
            Colour
            {hasSwatches && (
              <span className="ml-2 text-[#D4AF37] normal-case tracking-normal" data-testid="color-variants-count">
                {variants.length} colours available
              </span>
            )}
          </p>
          <p className="text-sm font-work text-[#0A0A0A]" data-testid="product-color">{color}</p>

          {hasSwatches && (
            <div className="flex flex-wrap gap-2 mt-3">
              {variants.map(v => (
                <button
                  key={v.product_id}
                  type="button"
                  title={`${v.color}${v.in_stock ? '' : ' — sold out, request to source'}`}
                  aria-label={`View ${v.color}`}
                  aria-current={v.is_current ? 'true' : undefined}
                  disabled={v.is_current}
                  onClick={() => navigate(`/product/${v.product_id}`)}
                  className={`relative w-16 h-16 bg-[#F5F5F5] overflow-hidden border-2 transition-all duration-200 ${
                    v.is_current
                      ? 'border-[#D4AF37] cursor-default'
                      : 'border-transparent hover:border-[#0A0A0A] hover:-translate-y-0.5'
                  }`}
                  data-testid={`color-swatch-${v.product_id}`}
                >
                  <img src={v.image} alt={v.color} className="w-full h-full object-cover" loading="lazy" />
                  {!v.in_stock && (
                    <span className="absolute inset-x-0 bottom-0 bg-white/85 text-[7px] uppercase tracking-wider text-[#999999] font-work text-center py-0.5">
                      Request
                    </span>
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
      )}

      {gender && (
        <div>
          <p className="text-[10px] uppercase tracking-[0.2em] text-[#AAAAAA] font-work mb-1">For</p>
          <p className="text-sm font-work text-[#0A0A0A]">{gender}</p>
        </div>
      )}
    </div>
  );
}
